'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = function (componentName, defaultLocale) {
    return function (Component) {
        var ComponentWithStatics = Component;
        return _a = function (_Component) {
            (0, _inherits3["default"])(_a, _Component);

            function _a() {
                (0, _classCallCheck3["default"])(this, _a);
                return (0, _possibleConstructorReturn3["default"])(this, _Component.apply(this, arguments));
            }

            _a.prototype.getLocale = function getLocale() {
                var antLocale = this.context.antLocale;

                var localeFromContext = antLocale && antLocale[componentName];
                var localeFromProps = this.props.locale || {};
                return (0, _extends3["default"])({}, defaultLocale, localeFromContext || {}, localeFromProps);
            };

            return _a;
        }(Component), _a.propTypes = ComponentWithStatics.propTypes, _a.defaultProps = ComponentWithStatics.defaultProps, _a.contextTypes = (0, _extends3["default"])({}, ComponentWithStatics.context || {}, { antLocale: _react.PropTypes.object }), _a;
        var _a;
    };
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/injectLocale.tsx
 ** module id = 53
 ** module chunks = 0 1
 **/